import { Component } from '@angular/core';
import { NavController, ModalController, Config } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';

import { Data } from '../../providers/providers';

import { LocationDetailPage } from '../location-detail/location-detail';
import { LocationEditPage } from '../location-edit/location-edit';

import { Location } from '../../models/location';
import {AboutLocationsPage} from "../about-locations/about-locations";
import {PrivacyPage} from "../privacy/privacy";


@Component({
  selector: 'page-location-list',
  templateUrl: 'location-list.html'
})
export class LocationListPage {

  years: number[] = [ moment().year(), moment().year() - 1, -1];
  locationFilter: number = this.years[0];
  maskingForm: FormGroup;

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController,
              public config: Config,
              formBuilder: FormBuilder,
              public data: Data)
  {
    // console.log(config);

    // masking form
    this.maskingForm = formBuilder.group({
      email: ['', null]
    });
    this.maskingForm.valueChanges.subscribe((v) => {
      if (v.email) {
        this.data.maskAsUser(v.email);
        this.maskingForm.reset();
      }
    });
  }

  matchesFilter(location) {
    if (location.year == this.years[0] || location.year == this.years[1]) {
      return this.locationFilter == location.year;
    }
    else {
      return this.locationFilter == -1;
    }
  }

  addLocation() {
    let addModal = this.modalCtrl.create(LocationEditPage);
    addModal.onDidDismiss(location => {
      if (location) {
        this.data.addLocation(location);
      }
    })
    addModal.present();
  }

  openLocation(location: Location) {
    this.navCtrl.push(LocationDetailPage, {
      location: location
    });
  }

  openAbout() {
    this.navCtrl.push(AboutLocationsPage, {});
  }

  openPrivacy() {
    this.navCtrl.push(PrivacyPage, {});
  }
}





// WEBPACK FOOTER //
// ./src/pages/location-list/location-list.ts